module.exports = __webpack_public_path__ + "static/06-8634c0a08c72a5d85be419c0e54cf5d3.jpg";